import React from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// Reusable date picker: form styling, full width and "pick only, no typing" are set here once.
//
// Usage:
//   <DatePickerComponent mode="month" selected={date} onChange={(date) => ...} minDate={...} maxDate={...} />
//
// mode="month" shows a month / year picker (default format "MMMM-yyyy"); any other mode shows a day picker.
// Any other react-datepicker prop is passed straight through.
export default function DatePickerComponent(props) {
	var { mode, allowTyping, dateFormat, className, wrapperClassName, ...pickerProps } = props;
	var isMonthPicker = mode == "month";

	return (
		<DatePicker
			showMonthYearPicker={isMonthPicker}
			dateFormat={dateFormat || (isMonthPicker ? "MMMM-yyyy" : "dd-MM-yyyy")}
			onKeyDown={allowTyping ? undefined : (e) => e.preventDefault()}
			className={className || "form-control"}
			wrapperClassName={wrapperClassName || "w-100 d-block"}
			{...pickerProps}
		/>
	);
}
